import pallete from "./pallete";

function createItem(order, index) {
  const idxString = (index + 1).toString();
  const id = idxString;
  const rowId = order.rowId || idxString;
  const label = order.codigo;
  let background;
  let moveable = true;
  const time = {
    start: order.inicio,
    end: order.fim,
  };
  if (order.isInterval) {
    background = pallete[pallete.length - 1];
    moveable = false;
  } else {
    background = order.background || pallete[index + 3];
  }
  const now = new Date().getTime();
  if (time.start < now && !order.moveable) {
    moveable = false;
  }

  return {
    id,
    label,
    rowId,
    time,
    moveable,
    uuid: order.uuid,
    style: {
      background,
    },
  };
}

function createItems(orderModelList) {
  const items = {};

  orderModelList.forEach((order, index) => {
    const idxString = (index + 1).toString();
    items[idxString] = createItem(order, index);
  });
  return items;
}

export default {
  createItem,
  createItems,
};
